export const DELAY_BEFORE_DISPLAY = 3000
export const SHOW_ONLY_IN_PROD = true
